/**
 * Normalizes a Contentful variant value to kebab-case.
 * Handles plain Title Case ("2 Col Default" → "2-col-default") and
 * the "+" separator used in Hero variant names
 * ("Video + Copy + CTA" → "video-copy-cta").
 */
export const normalizeVariant = (variant?: string | null): string | undefined =>
  variant
    ?.toLowerCase()
    .replace(/\s*\+\s*/g, "-")
    .replace(/\s+/g, "-");

/**
 * @param text The text to be processed
 * @param container The container in which the text should fit
 *
 * @returns string[] - Array of text lines
 */
export const getWrappedLines = (
  text: string,
  container: HTMLElement | null
) => {
  if (!container) return [];

  const rects: DOMRect[] = [];
  const words = text.split(" ");
  const formattedLines = [];
  let currentLine: string[] = [];
  const buffer: HTMLElement[] = [];

  words.forEach((word: string, index: number) => {
    const span = document.createElement("span");
    span.textContent = word + (index !== words.length - 1 ? " " : "");
    container.appendChild(span);

    const rect = span.getBoundingClientRect();
    if (index > 0 && rects[index - 1].top !== rect.top) {
      formattedLines.push(currentLine.join(" "));
      currentLine = [];
    }
    rects.push(rect);

    currentLine.push(word);
    buffer.push(span);
  });

  buffer.forEach((item) => {
    container.removeChild(item);
  });

  if (currentLine.length) {
    formattedLines.push(currentLine.join(" "));
  }

  return formattedLines;
};
